import React from 'react'

const ResumeCard = ({ title, subTitle, result, des }) => {
  return (
    <div
      className="w-full group flex"
      style={{ gap: "0" }}
    >
      {/* Timeline dot + line */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginRight: "20px", paddingTop: "4px" }}>
        <div style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          border: "2px solid #1e2228",
          background: "#0a0b0d",
          transition: "all 0.3s ease",
          flexShrink: 0,
          marginTop: "6px",
        }}
          className="group-hover:border-red-500 group-hover:bg-red-500 group-hover:shadow-[0_0_12px_#ff014f66]"
        />
        <div style={{
          width: "1px",
          flex: 1,
          background: "linear-gradient(to bottom, #1e2228, transparent)",
          marginTop: "8px",
        }} />
      </div>

      {/* Card */}
      <div
        style={{
          flex: 1,
          background: "#13151a",
          border: "1px solid #1e2228",
          borderRadius: "10px",
          padding: "18px 22px",
          marginBottom: "20px",
          transition: "all 0.3s ease",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = "#ff014f33";
          e.currentTarget.style.background = "#16181f";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = "#1e2228";
          e.currentTarget.style.background = "#13151a";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap" }}>
          <div style={{ flex: 1 }}>
            <h3 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: "16px",
              fontWeight: 700,
              color: "#f0f2f5",
              marginBottom: "4px",
            }}>
              {title}
            </h3>
            <p style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "12px",
              color: "#8892a4",
            }}>
              {subTitle}
            </p>
          </div>
          <span style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "11px",
            color: "#ff014f",
            background: "#ff014f15",
            border: "1px solid #ff014f33",
            borderRadius: "5px",
            padding: "4px 10px",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}>
            {result}
          </span>
        </div>
        <p style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "13.5px",
          lineHeight: 1.75,
          color: "#6b7688",
        }}>
          {des}
        </p>
      </div>
    </div>
  );
}

export default ResumeCard;